import { DocumentStatusEnum } from "@models/documents/document-status.enum";
import { DocumentStepEnum } from "@models/documents/document-step.enum";

export function documentStatusToStep(documentStatus: DocumentStatusEnum | null | undefined): number {
  const documentStatusToStepMap = {
    [DocumentStatusEnum.Draft]: DocumentStepEnum.InitiateChange,
    [DocumentStatusEnum.AuthorisationPending]: DocumentStepEnum.InitiateChange,
    [DocumentStatusEnum.SignaturePending]: DocumentStepEnum.SignDocuments,
    [DocumentStatusEnum.LodgementPending]: DocumentStepEnum.SignDocuments,
    [DocumentStatusEnum.Completed]: DocumentStepEnum.AsicResponse,
  };

  if(documentStatus !== null && documentStatus !== undefined) {
    return documentStatusToStepMap[documentStatus] as number;
  }

  return 0;
}
